<template>
	<section @click.stop>
		<img src="@/assets/images/1.png" class="triangle triangle-l" />
		<div class="box flexJA flexSb">
			<h1 class="title-text">联想拯救者电竞耳机 Y960</h1>
			<div class="headphone flexJA">
				<div class="headphone-image">
					<img src="@/assets/images/3-2.png" class="image" />
					<div class="line line-1" @click="nav('/configuration?type=1')"><span class="flexJA">设备</span></div>
					<div class="line line-2" @click="nav('/configuration?type=2')"><span class="flexJA">灯效</span></div>
					<div class="line line-3" @click="nav('/configuration?type=3')"><span class="flexJA">声音</span></div>
					<div class="line line-4" @click="nav('/configuration?type=4')"><span class="flexJA">音效</span></div>
				</div>
			</div>
		</div>
		<img src="@/assets/images/2.png" class="triangle triangle-r" />
		
		<el-dialog title="提示" :visible="ValidationShow" width="500px" @close="ValidationShow = false">
			<div class="tip flexJA flexFs">
				<img src="@/assets/images/mid.png">
				<div>
					<div style="font-size: 14px;color: #fff;line-height: 30px;">非法设备</div>
					<div>请联系售后处理。</div>
				</div>
			</div>
			<div class="btns flexJA flexFe">
				<div class="btn btn-1 flexJA" @click="ValidationShow = false">确认</div>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { mapState } from 'vuex'
	import Upgrade from '@/components/Upgrade'
	import http from '../../utils/http';
	export default {
		name: 'index',
		components: {
			Upgrade,
		},
		data() {
			return {
				Validation: -1,
				ValidationShow: false
			}
		},
		computed: {
			...mapState({
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
				dialogRestoreFactory: (state) => state.dialogRestoreFactory,
			}),
		},
		mounted() {
			this.getUpdate();
		},
		methods: {
			nav(url) {
				if(this.Upgrade.status && this.equipmentStatus) {
					this.$store.commit('setUpgrade', {dialogStatus: true});
					return
				}
				
				// 4.1设备状态GetDeviceStatus
				// 返回：{"code": 1, "msg": "AT_DEVICE_LINKED"}  or  {"code": 1, "msg": "AT_DEVICE_NOTLINKED"}
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetDeviceStatus", null).then(res=>{
					console.log(res)
					this.$store.commit('gotState', {key: 'equipmentStatus', data: res.msg != "AT_DEVICE_LINKED"})
					if(res.msg != "AT_DEVICE_LINKED") {
						// this.$message({ message: '设备未连接', type: 'warning' });
						this.Validation == -1;
						this.$store.commit('setUpgrade', {status: false});
						// this.$router.push(url);
					}else {
						if(!sessionStorage.getItem('Validation')) {
							this.GetValidation(url);
						}else {
							let Version = localStorage.getItem('Version');
							if(!Version && !sessionStorage.getItem('VersionLow')) {
								this.GetLightDataSV(url);
								this.getUpdate();
							}else if(Version < 'V0.81.9' && !sessionStorage.getItem('VersionLow')){
								this.GetLightDataSV(url);
								this.getUpdate();
							}else {
								this.next(url);
							}
						}
					}
				}).catch(err=>{
					console.error(err)
					this.$store.commit('setUpgrade', {status: false});
					this.$store.commit('gotState', {key: 'equipmentStatus', data: true})
					// this.$message({ message: '设备未连接', type: 'warning' });
				});
			},
			GetValidation(url, num = 0) {
				// 4.5设备认证
				// window.LegionZone.nativeCall("LenovoHeadset.dll","GetValidation",null)
				// 返回：{"code": 1, "msg": "Validation Success."}  or  {"code": -1, "msg": "Validation Fail."}
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetValidation", null).then(res=>{
					console.log('LenovoHeadset.dll[GetValidation]: ', res);
					if(res.code != 1) {
						if(num < 4) {
							setTimeout(e=>{
								this.GetValidation(url, num + 1);
							},50)
						}else {
							this.ValidationShow = true;
							this.Validation = 0;
						}
						// this.$message({ message: '非法设备，请联系售后处理', type: 'warning' });
					}else {
						if(!sessionStorage.getItem('VersionLow')) {
							this.GetLightDataSV(url);
							this.getUpdate();
						}else {
							sessionStorage.setItem('Validation', 1);
							this.Validation = 1;
							this.next(url);
						}
					}
				}).catch(err=>{
					console.log('LenovoHeadset.dll[GetValidation]: ', err);
					this.$message({ message: '非法设备，请联系售后处理', type: 'warning' });
				});
			},
			GetLightDataSV(url) {
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetLightDataSV",null).then(res=>{
					console.log('LenovoHeadset.dll[GetLightDataSV]: ', res)
					if(res.ver && res.ver.indexOf('V255.255.255') == -1 && res.ver.indexOf('V22') == -1) {
						localStorage.setItem('Version', res.ver);
						let Version = localStorage.getItem('Version');
						if(Version < 'V0.81.9'){
							this.$store.commit('gotState', {key: 'nextUrl', data: url});
							this.$store.commit('gotState', {key: 'VersionLowStatus', data: true});
						}else {
							this.next(url);
						}
					}else {
						this.GetLightDataSV(url);
					}
				}).catch(err => {
					this.GetLightDataSV(url);
					console.error('LenovoHeadset.dll[GetLightDataSV]: ', err)
				});
			},
			async getUpdate(num = 0) {
				try {
					let StorageUpdate = localStorage.getItem('update') ? JSON.parse(localStorage.getItem('update')) : {};
					const update = await http.get('/lot/file/download?filename=update.json');
					console.log(update);
					window.LZPlugin.nativeCall("FileDownloader.dll", "download_file", `${update.url}|D:/Downloads`).then(res=>{
						console.log('FileDownloader.dll[DownloadFileToLocal]: ', res);
						if(res.code == 0) {
							localStorage.setItem('update', JSON.stringify(update))
							this.$store.commit('gotState', {key: 'update', data: update});
						}else {
							if(num < 3) {
								this.getUpdate(num + 1);
							}
						}
					}).catch(err => {
						console.error('FileDownloader.dll[DownloadFileToLocal]: ', err);
					});
				} catch (error) {
					console.error(error);
				}
			},
			next(url) {
				let loading;
				loading = this.$loading({
					lock: true,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 1)',
					customClass: 'custom-background'
				});
				setTimeout(e=>{
					this.$router.push(url);
				},400)
				setTimeout(() => {
				  loading.close();
				}, 2000);
			}
		},
		mounted() {
			
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/deep.scss';
	
	.triangle {
		width: 106px;
		height: 213px;
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}
	
	.triangle-r {
		left: inherit;
		right: 0;
	}
	
	.box {
		flex: 1;
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	
	.headphone {
		flex: 1;
		width: 100%;
		align-items: flex-start;
		
		.headphone-image {
			width: 373px;
			height: 500px;
			position: relative;
		}
		
		.image {
			width: 373px;
			height: 500px;
		}
		
		.line {
			cursor: pointer;
			position: absolute;
			
			span {
				font-family: Microsoft YaHei;
				font-weight: 700;
				font-style: Bold;
				font-size: 14px;
				line-height: 14px;
				position: absolute;
			}
		}
		
		.line-1 {
			width: 145px;
			height: 79px;
			top: 15px;
			left: -4px;
			background-image: url('../assets/images/4-1.png');
			background-size: 145px 79px;
			
			&:hover {
				background-image: url('../assets/images/4-2.png');
			}
			
			span {
				width: 80px;
				height: 38px;
				left: 0;
				top: 0;
			}
		}
		
		.line-2 {
			width: 165px;
			height: 96px;
			top: 180px;
			right: -130px;
			background-image: url('../assets/images/5-1.png');
			background-size: 165px 96px;
			
			&:hover {
				background-image: url('../assets/images/5-2.png');
			}
			
			span {
				width: 90px;
				height: 38px;
				right: 0;
				top: 0;
			}
		}
		
		.line-3 {
			width: 155px;
			height: 41px;
			top: 293px;
			left: -44px;
			background-image: url('../assets/images/6-1.png');
			background-size: 155px 41px;
			
			&:hover {
				background-image: url('../assets/images/6-2.png');
			}
			
			span {
				width: 80px;
				height: 44px;
				left: 0;
				top: 0;
			}
		}
		
		.line-4 {
			width: 155px;
			height: 41px;
			top: 383px;
			right: -25px;
			background-image: url('../assets/images/7-1.png');
			background-size: 155px 41px;
			
			&:hover {
				background-image: url('../assets/images/7-2.png');
			}
			
			span {
				width: 90px;
				height: 43px;
				right: 0;
				top: 0;
			}
		}
	}
</style>